import React, { useState } from "react";

import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { postHolidays } from "../../../../MyApi/sb/Holidays";

import PageHeader from "../../../../Components/UI/PageHeader";
import AddHolidays from "../../../../Components/sb/holidays/holidaysStore/AddHolidays";

const HolidaysStore = () => {
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [description, setDescription] = useState("");
  const [sb_branch_id, setSbBranchId] = useState("");
  const [sb_employe_id, setSbEmployeId] = useState("");
  const [sb_company_id, setSbCompanyId] = useState("");
  const [active, setActive] = useState(1);

  const mutation = useMutation(
    "postHolidays",
    (postData) => postHolidays(postData),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        setName("");
        setDescription("");
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );

  const handlePostRequest = () => {
    mutation.mutate({
      name,
      description,
      active,
      date,
      sb_branch_id,
      sb_employe_id,
      sb_company_id,
    });
  };
  const isDisabled = () => {
    return !name;
  };

  return (
    <div>
      <PageHeader
        title="Add Holidays"
        isLoading={mutation.isLoading}
        showBack={true}
        saveButton={true}
        isdisbled={isDisabled}
        handlePostRequest={handlePostRequest}
      />
      <AddHolidays
        setActive={setActive}
        active={active}
        setName={setName}
        setSbBranchId={setSbBranchId}
        setSbEmployeId={setSbEmployeId}
        setSbCompanyId={setSbCompanyId}
        name={name}
        sb_branch_id={sb_branch_id}
        sb_employe_id={sb_employe_id}
        sb_company_id={sb_company_id}
        description={description}
        setDate={setDate}
        date={date}
        setDescription={setDescription}
      />
    </div>
  );
};

export default HolidaysStore;
